import {
  call, put, takeLatest, all, select,
} from 'redux-saga/effects';
import { authRequest } from '../../helpers/request.helper';
import {
  INICIAR_VENTANA_TRAZADORA,
  OBTENER_SUPLEMENTOS_TRAZADORA_REQUEST
} from '../actions/constants/trazadora.constants';
import {convertirSuplementosPel, formatearDatosLente} from "../../helpers/modules/trazadora.helper";
import {setVisible} from "../actions/creators/trazadora.actioncreator";

const trazadoraState = state => state.trazadora;
const authState = state => state.auth;

function* trazadoraSaga() {
  yield all([
  ]);
}

export default trazadoraSaga;
